import React, { Component } from 'react'
import {
    MuiTableCell, MuiTableRow, MuiTableHead
} from '../../ui/MaterialUIComponents'
import theme from '../../../assests/theme'

export default function OrderHeaderComponent(props) {
    return (
        <MuiTableHead style={theme.tableHeaderStyle1}>
            <MuiTableRow>
                <MuiTableCell align="center" style={theme.tableHeaderTextStyle} >{props.i18n.orderHistory.date}</MuiTableCell>
                <MuiTableCell align="center" style={theme.tableHeaderTextStyle} >{props.i18n.orderHistory.orderId}</MuiTableCell>
                <MuiTableCell align="center" style={theme.tableHeaderTextStyle} >{props.i18n.orderHistory.item}</MuiTableCell>
                <MuiTableCell align="center" style={theme.tableHeaderTextStyle} >{props.i18n.orderHistory.amount} ({" "+props.orderHistory[0].currency+" "})</MuiTableCell>
                <MuiTableCell align="center" style={theme.tableHeaderTextStyle} >{props.i18n.orderHistory.status}</MuiTableCell>
                <MuiTableCell align="center" style={theme.tableHeaderTextStyle} >{props.i18n.orderHistory.invoice}</MuiTableCell>
            </MuiTableRow>
        </MuiTableHead>

    )
}



